import React from 'react'
import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'

import { LinearGradient } from 'expo-linear-gradient'
import styled, { useTheme } from 'styled-components/native'

import { Title } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/title/Title'
import { TitleSize } from '@lyrahealth-inc/ui-core-crossplatform/src/styles/typeStyles'

import Agenda from './agenda/Agenda'
import CaseloadCounter from './caseloadCounter/CaseloadCounter'
import OpenItems from './openItems/OpenItems'
import { getAuthUser } from '../data/auth/authSelectors'

const Container = styled(LinearGradient)(({ theme }) => ({
  padding: theme.spacing['24px'],
  gap: theme.spacing['24px'],
  flex: 1,
}))

const Row = styled.View(({ theme }) => ({
  flex: 1,
  flexDirection: 'row',
  alignItems: 'flex-start',
  gap: theme.spacing['24px'],
}))

const HeaderRow = styled.View(({ theme }) => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: theme.spacing['16px'],
}))

const Dashboard: React.FC = () => {
  const theme = useTheme()
  const user = useSelector(getAuthUser)
  return (
    <Container
      colors={[
        theme.colors.components.providerBackgroundGradient.start.background,
        theme.colors.components.providerBackgroundGradient.end.background,
      ]}
    >
      <HeaderRow>
        <Title
          size={TitleSize.LARGE}
          text={
            <FormattedMessage
              defaultMessage='Welcome, {firstName}'
              description='Welcome message on dashboard'
              values={{ firstName: user?.first_name }}
            />
          }
        />
        <CaseloadCounter />
      </HeaderRow>

      <Row>
        <OpenItems />
        <Agenda />
      </Row>
    </Container>
  )
}

export default Dashboard
